export class AnimationChain {
    constructor(animations, params) {
        this.animations = animations;
        this.delay = params?.delay || 0;
    }

    getAnimationTime() {
        return this.animations.reduce((agg, cur) => agg + cur.getAnimationTime(), 0) + this.delay;
    }

    animate(time) {
        const truncatedTime = this.getTruncatedAnimationTime(time);

        if (truncatedTime <= this.delay) {
            return null;
        }

        const {
            currentAnimation,
            currentAnimationTime,
        } = this.getCurrentAnimation(truncatedTime - this.delay);
        
        return currentAnimation ? currentAnimation.animate(currentAnimationTime) : null;
    }

    isAnimationFinished(time) {
        const fullTime = this.getAnimationTime();
        return time > fullTime;
    }

    getTruncatedAnimationTime(time) {
        const fullTime = this.getAnimationTime();
        return time > fullTime ? fullTime : time;
    }

    getCurrentAnimation(time) {
        let animation = null;
        let animationTime = null;

        let timeSum = 0;

        for (let i = 0; i < this.animations.length; i++) {
            const currentAnimation = this.animations[i];
            const currentAnimationTime = currentAnimation.getAnimationTime();

            if (timeSum + currentAnimationTime >= time) {
                animation = currentAnimation;
                animationTime = time - timeSum;

                break;
            }

            timeSum += currentAnimationTime;
        }

        return {
            currentAnimation: animation,
            currentAnimationTime: animationTime,
        };
    }
}